import {Button} from '@shm/ui/button'
import {Dialog, DialogContent, DialogHeader, DialogTitle} from '@shm/ui/components/dialog'
import {Check, Code, HeadingIcon, Type, X} from '@shm/ui/icons'
import {SizableText} from '@shm/ui/text'
import {cn} from '@shm/ui/utils'

interface MobileTextTypeDialogProps {
  isOpen: boolean
  onClose: () => void
  currentValue: string
  onChange: (value: string) => void
}

const textTypeOptions = [
  {
    label: 'Paragraph',
    value: 'paragraph',
    icon: <Type className="size-5" />,
  },
  {
    label: 'Heading',
    value: 'heading',
    icon: <HeadingIcon className="size-5" />,
  },
  {
    label: 'Code Block',
    value: 'code-block',
    icon: <Code className="size-5" />,
  },
]

export function MobileTextTypeDialog({isOpen, onClose, currentValue, onChange}: MobileTextTypeDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={() => {}}>
      <DialogContent
        className="h-full max-h-full w-full max-w-full rounded-none p-0"
        showCloseButton={false}
        onEscapeKeyDown={(e) => {
          e.preventDefault()
          onClose()
        }}
        onInteractOutside={(e) => {
          e.preventDefault()
          onClose()
        }}
      >
        <div className="flex h-full flex-col">
          <DialogHeader className="border-b p-4">
            <div className="flex items-center justify-between">
              <DialogTitle>Text Type</DialogTitle>
              <Button size="icon" variant="ghost" onClick={onClose} className="size-8">
                <X className="size-4" />
              </Button>
            </div>
          </DialogHeader>

          <div className="flex-1 overflow-y-auto">
            <div className="divide-y">
              {textTypeOptions.map((option) => (
                <Button
                  key={option.value}
                  variant="ghost"
                  className={cn('h-auto w-full justify-start px-4 py-4', currentValue === option.value && 'bg-muted')}
                  onClick={() => onChange(option.value)}
                >
                  <div className="flex w-full items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="bg-muted flex size-10 items-center justify-center rounded-md">{option.icon}</div>
                      <SizableText weight="medium">{option.label}</SizableText>
                    </div>
                    {currentValue === option.value && <Check size={20} color="currentColor" />}
                  </div>
                </Button>
              ))}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
